import React from 'react';
import RootContainer from './container/RootContainer';
import {Route} from 'react-router-dom'

import './assets/sass/index.scss'
import Loader from './container/Loader';

function App() {
  return (
    <div className="App">
      <Loader />
      <Route path='/:phone?' component={RootContainer} />
    </div>
  );
}

export default App;
